"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _types = require("../types");

var stringConversion = function stringConversion(toConvert) {
  try {
    return typeof toConvert === 'string' ? JSON.parse(toConvert) : JSON.stringify(toConvert);
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error("Error loading state at " + _types.KEY);
    return undefined;
  }
};

var _default = stringConversion;
exports["default"] = _default;